/*
* Copyright (C) Regione Lombardia
*/
import { Pipe, PipeTransform } from '@angular/core';
import { AnagraficaTipologiaOpera } from '@models';

@Pipe({
    name: 'anagraficaTipologiaOpera',
})
export class AnagraficaTipologiaOperaPipe implements PipeTransform {

    transform(value: number, items: AnagraficaTipologiaOpera[]) {
        return items.find(i => i.idTipologiaOpera === value)?.descrizioneTipologiaOpera || '';
    }

}
